import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99623c58&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AudioPlayer: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AudioPlayer/index.vue').default,ImageComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ImageComponent/index.vue').default,RatingTag: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RatingTag/index.vue').default,Status: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Status/index.vue').default,RoundButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RoundButton/index.vue').default,LabelTag: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LabelTag/index.vue').default})
